import React from 'react';
import { AUTH_LOGIN } from 'utilities/routes';
import { ReactComponent as SgbnetIcon } from 'assets/icons/admin-logo.svg';
import { Outlet, useNavigate } from 'react-router-dom';

const Layout = () => {
  const navigate = useNavigate();
  return (
    <div className="w-screen h-screen admin-pages bg-base-content">
      <div className="w-full hidden h-[90px] py-2.5 bg-header desktop:flex items-center justify-center gap-2.5 px-36 border-b shrink-0 p-0">
        <SgbnetIcon
          onClick={() => navigate(AUTH_LOGIN)}
          className="cursor-pointer h-5 w-40 min-h-[20px]"
        />
        <div className="h-full flex items-center text-center border-l pl-2.5 border-[#848484] font-semibold text-white">
          Admin
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Layout;
